import styled from 'styled-components'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const Background = styled.div`
  background: ${({ theme }) => theme.colors.footerBackground};
  padding: 2rem 0;

  @media (min-width: 768px) {
    padding: 1.5rem;
  }
`

export const Nav = styled.nav`
  display: flex;
`

export const Breadcrumb = styled.li`
  margin: 0;
  padding: 0;

  a {
    &:hover {
      color: ${({ theme }) => theme.colors.text.secondary};
      text-decoration: underline;
    }
    &:visited {
      color: ${({ theme }) => theme.colors.text.secondary};
    }
  }
`

export const Arrow = styled(ArrowDownIcon)`
  margin-left: 1rem;
  transform: rotate(-90deg);
  width: 0.8rem;
  height: 0.8rem;

  path {
    stroke: ${({ theme }) => theme.colors.text.secondary}!important;
    stroke-width: 4px;
  }
`

export const Breadcrumbs = styled.ol`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0 1.7rem 1.7rem;
  max-width: 1600px;
  margin: 0 auto;
  flex: 1;
  align-items: center;
  gap: 1rem;
`

export const Menus = styled.div`
  padding: 1.7rem;
  max-width: 1600px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 4.2rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const Menu = styled.div`
  max-width: 24rem;
`

export const SecondLevel = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const SecondLevelItem = styled.li`
  padding: 0.5rem 0;

  a {
    &:hover {
      color: ${({ theme }) => theme.colors.text.secondary};
      text-decoration: underline;
    }
    &:visited {
      color: ${({ theme }) => theme.colors.text.secondary};
    }
  }
`

export const PaymentsImage = styled(ResponsiveImage)`
  display: block;
  margin: 3rem auto;
  width: 90%;
  max-width: 35rem;
  height: auto;
`

export const Separator = styled.hr`
  border-top: 1px solid ${({ theme }) => theme.colors.footerSeparator};
  margin: 0 auto;
  max-width: 1600px;
`

export const LegalNotes = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 8rem;
  padding: 0 1.7rem;

  @media (min-width: 768px) {
    padding: 0;
  }
`

export const Legal = styled.ul`
  margin: 2rem 0 0 0;
  padding: 0;
  display: flex;
  list-style: none;
  flex-wrap: wrap;
  gap: 0.5rem 2.4rem;

  @media (max-width: 420px) {
    gap: 0.5rem 1rem;
  }

  a {
    &:hover {
      color: ${({ theme }) => theme.colors.text.secondary};
      text-decoration: underline;
    }
  }
`
